<div id="wrapper" #wrapper [ngStyle]="{ 'padding-top': navigation?.nActiveFilters ? '30px' : '0' }">
  <div>
    <div id="left-column">
      <div style="height: 100%; position: relative; display: flex; flex-direction: column" *ngIf="!forceMenu">
        <!-- image section start  -->
        <span (click)="forceMenu = true" class="back-btn"
          ><i style="color: #2763cd" class="fa fa-arrow-left"></i> Back</span
        >
        <div class="dual-monitor-icon" (click)="togglePopup()" *ngIf="showPictures || !popupClosed">
          <svg
            *ngIf="popupClosed"
            width="20"
            height="20"
            viewBox="0 0 26 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22 13H24V2H8V4H6V1.007C6 0.451 6.455 0 6.992 0H25.008C25.556 0 26 0.449 26 1.007V13.993C26 14.549 25.545 15 25.008 15H22V13Z"
              fill="#2763CD" />
            <path
              d="M2.00004 19H18V8H2.00004V19ZM11 21V23H15V25H5.00004V23H9.00004V21H0.992041C0.860727 20.9992 0.730858 20.9725 0.609879 20.9215C0.488899 20.8704 0.379188 20.7959 0.287032 20.7024C0.194877 20.6088 0.122089 20.498 0.0728414 20.3763C0.0235937 20.2546 -0.00114581 20.1243 4.07459e-05 19.993V7.007C4.07459e-05 6.451 0.455041 6 0.992041 6H19.008C19.556 6 20 6.449 20 7.007V19.993C20 20.549 19.545 21 19.008 21H11Z"
              fill="#2763CD" />
          </svg>
          <svg
            *ngIf="!popupClosed"
            width="20"
            height="20"
            viewBox="0 0 26 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22 13H24V2H8V4H6V1.007C6 0.451 6.455 0 6.992 0H25.008C25.556 0 26 0.449 26 1.007V13.993C26 14.549 25.545 15 25.008 15H22V13Z"
              fill="#2763CD" />
            <path
              d="M2.00004 19H18V8H2.00004V19ZM11 21V23H15V25H5.00004V23H9.00004V21H0.992041C0.860727 20.9992 0.730858 20.9725 0.609879 20.9215C0.488899 20.8704 0.379188 20.7959 0.287032 20.7024C0.194877 20.6088 0.122089 20.498 0.0728414 20.3763C0.0235937 20.2546 -0.00114581 20.1243 4.07459e-05 19.993V7.007C4.07459e-05 6.451 0.455041 6 0.992041 6H19.008C19.556 6 20 6.449 20 7.007V19.993C20 20.549 19.545 21 19.008 21H11Z"
              fill="#2763CD" />
            <rect
              x="8.00195"
              y="10.3418"
              width="7.53511"
              height="1.88378"
              transform="rotate(45 8.00195 10.3418)"
              fill="#2763CD" />
            <rect
              x="6.66992"
              y="15.6699"
              width="7.53511"
              height="1.88378"
              transform="rotate(-45 6.66992 15.6699)"
              fill="#2763CD" /></svg
          >&nbsp;
          <a>{{ popupClosed ? 'Activate' : 'Deactivate' }} dual-monitor</a>
        </div>

        <app-answer-pictures
          #answerPictures
          (close)="forceMenu = true"
          [answer]="answer"
          style="flex: 5"
          *ngIf="showPictures; else showDualMonitor"
          (answerChange)="answerChange($event, false)"
          [navigatedByArrow]="navigatedByArrow"
          (flagChange)="refreshFlags()"
          (updateCounter)="getFlagsAndComments()">
        </app-answer-pictures>

        <ng-template #showDualMonitor>
          <ng-container *ngIf="!popupClosed">
            <ng-container *ngTemplateOutlet="dualModeActivated"></ng-container>
          </ng-container>
        </ng-template>

        <ng-template #dualModeActivated>
          <div class="dual-monitor-container">
            <div>
              <svg width="30" height="30" viewBox="0 0 52 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M43.9998 26H47.9999V3.99999H16V7.99999H12V2.014C12 0.901999 12.91 0 13.984 0H50.0159C51.1119 0 51.9999 0.897999 51.9999 2.014V27.986C51.9999 29.098 51.0899 30 50.0159 30H43.9998V26Z"
                  fill="#3EB775" />
                <path
                  d="M4.00008 38H36V16H4.00008V38ZM22 42V46H30V49.9999H10.0001V46H18.0001V42H1.98408C1.72145 41.9984 1.46171 41.945 1.21976 41.8429C0.977797 41.7407 0.758374 41.5918 0.574063 41.4047C0.389753 41.2176 0.244178 40.996 0.145683 40.7526C0.0471873 40.5091 -0.00229162 40.2486 8.14918e-05 39.986V14.014C8.14918e-05 12.902 0.91008 12 1.98408 12H38.016C39.112 12 40 12.898 40 14.014V39.986C40 41.098 39.09 42 38.016 42H22Z"
                  fill="#3EB775" />
              </svg>
              <span style="color: #3eb775; font-size: 18px; font-weight: bold"> Dual monitor mode enabled</span>
            </div>
            <div>
              <button class="btn aru btn-ghost-danger" (click)="closePopup()">Deactivate</button>
            </div>
          </div>
        </ng-template>

        <!-- section end -->

        <!-- Violation and Discr section Start -->
        <div
          class="div-50 overflow-auto p-3"
          id="answer-flags"
          style="flex: 3; display: flex"
          [ngStyle]="{ 'padding-top': showPictures ? '0' : '50px' }">
          <div class="flag-column">
            <h4>
              <span
                >Violations <span class="count">({{ violations().length }})</span></span
              >
              <span class="add-new-flag" *ngIf="question?.repeat?.length === 0" (click)="addFlag('Violation')"
                >Add new</span
              >
            </h4>
            <br />

            <div class="scrollable" forScroll cdkDropList cdkDropListSortingDisabled>
              <ng-container *ngFor="let flag of violations(); index as i">
                <div
                  class="flag"
                  [ngClass]="getFlagHighlightClass(flag)"
                  cdkDrag
                  (cdkDragReleased)="flagReleased(flag, $event)">
                  <div style="position: relative">
                    <div class="icon-left">
                      <i *ngIf="!scoresEnabled || !flag.score" class="fa fa-flag"></i>
                      <i *ngIf="scoresEnabled && flag.score" class="fa fa-warning"></i>
                    </div>
                    <p class="score" *ngIf="scoresEnabled && flag.score">{{ flag.score }}</p>
                    <svg
                      *ngIf="flag.picture?.key && answer.id == flag.answerId"
                      class="pin-icon"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      style="position: absolute; bottom: 0">
                      <path
                        d="M7.42282 10.5439L1.45659 4.5777C1.35609 4.4772 1.32574 4.32596 1.38037 4.19461C1.43475 4.06303 1.56293 3.97758 1.70519 3.97758C4.027 3.97758 6.11236 2.688 7.14801 0.612354L7.35703 0.194557C7.40728 0.0933302 7.50365 0.0226896 7.6151 0.00447869C7.72678 -0.0134744 7.84014 0.0231818 7.92002 0.103033L11.8975 4.08052C11.9774 4.16039 12.014 4.27376 11.9961 4.38544C11.9778 4.49686 11.9072 4.59324 11.806 4.64351L11.3884 4.85229C9.31249 5.88816 8.02293 7.97351 8.02293 10.2953C8.02293 10.4376 7.93748 10.5658 7.8059 10.6201C7.67456 10.6748 7.52332 10.6444 7.42282 10.5439Z" />
                      <path
                        d="M3.1962 7.3125L0.600143 9.90857C0.561542 9.94717 0.532409 9.99426 0.515182 10.046L0.0180025 11.5375C-0.0239975 11.664 0.00876813 11.8031 0.102963 11.8973C0.197159 11.9915 0.33626 12.0243 0.462753 11.9823L1.95432 11.4851C2.00602 11.4679 2.05313 11.4388 2.09173 11.4002L4.68781 8.80408L3.1962 7.3125Z" />
                    </svg>
                    <i *ngIf="answer.id != flag.answerId" class="fa fa-chain" style="position: absolute; bottom: 0"></i>
                  </div>
                  <div style="flex: 1; padding: 0 20px; max-width: 800px">
                    <p class="main-text" style="word-break: break-word">
                      <span *ngIf="buildingIndex(flag)">#{{ buildingIndex(flag) }} | </span> {{ flag.text }}
                    </p>
                    <p style="margin: 0; font-size: 13px">
                      <span class="username">{{ flag.user?.name }}</span> &nbsp; {{ dateTimeAsString(flag.updatedAt) }}
                      <a
                        href="javascript:void(0)"
                        style="cursor: pointer; font-style: italic; color: #7b8ead"
                        (click)="openChangelog()"
                        >(changelog)</a
                      >
                      &nbsp; <span class="flag-type">{{ flag.subtype?.type?.name }}</span>
                    </p>
                  </div>
                  <div class="icon-right" style="display: flex; flex-direction: column; text-align: right">
                    <div style="flex: 1">
                      <span cdkDragHandle *ngIf="!flag.pictureId" style="cursor: pointer; font-size: 11px">
                        drag over picture to pin &nbsp;
                        <svg class="pi-icon" height="12" style="fill: #7b8ead" viewBox="0 0 12 12" width="12">
                          <path
                            d="M7.42282 10.5439L1.45659 4.5777C1.35609 4.4772 1.32574 4.32596 1.38037 4.19461C1.43475 4.06303 1.56293 3.97758 1.70519 3.97758C4.027 3.97758 6.11236 2.688 7.14801 0.612354L7.35703 0.194557C7.40728 0.0933302 7.50365 0.0226896 7.6151 0.00447869C7.72678 -0.0134744 7.84014 0.0231818 7.92002 0.103033L11.8975 4.08052C11.9774 4.16039 12.014 4.27376 11.9961 4.38544C11.9778 4.49686 11.9072 4.59324 11.806 4.64351L11.3884 4.85229C9.31249 5.88816 8.02293 7.97351 8.02293 10.2953C8.02293 10.4376 7.93748 10.5658 7.8059 10.6201C7.67456 10.6748 7.52332 10.6444 7.42282 10.5439Z"></path>
                          <path
                            d="M3.1962 7.3125L0.600143 9.90857C0.561542 9.94717 0.532409 9.99426 0.515182 10.046L0.0180025 11.5375C-0.0239975 11.664 0.00876813 11.8031 0.102963 11.8973C0.197159 11.9915 0.33626 12.0243 0.462753 11.9823L1.95432 11.4851C2.00602 11.4679 2.05313 11.4388 2.09173 11.4002L4.68781 8.80408L3.1962 7.3125Z"></path>
                        </svg>

                        <div *cdkDragPreview>
                          <div class="flag-icon">
                            <i class="fa fa-flag"></i>
                          </div>
                          <div class="flag-tooltip">
                            <span class="flag-type" style="color: #eee; font-weight: bold">
                              {{ flag?.subtype?.type?.name }} - {{ flag?.subtype?.name }}
                            </span>
                            <br />
                            <span class="flag-text" style="color: #ddd; overflow-wrap: break-word">
                              {{ flag.text }}
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                    <i style="cursor: pointer" class="fa fa-pencil" (click)="editFlag(flag)"></i>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="flag-column">
            <h4>
              <span
                >Discrepancies <span class="count">({{ discrepancies().length }})</span></span
              >
              <span class="add-new-flag" *ngIf="question?.repeat?.length === 0" (click)="addFlag('Discrepancy')"
                >Add new</span
              >
            </h4>
            <br />

            <div class="scrollable" forScroll cdkDropList cdkDropListSortingDisabled>
              <ng-container *ngFor="let flag of discrepancies(); index as i">
                <div
                  class="flag"
                  [ngClass]="getFlagHighlightClass(flag)"
                  cdkDrag
                  (cdkDragReleased)="flagReleased(flag, $event)">
                  <div style="position: relative">
                    <div class="icon-left">
                      <i *ngIf="!scoresEnabled || !flag.score" class="fa fa-flag"></i>
                      <i *ngIf="scoresEnabled && flag.score" class="fa fa-warning"></i>
                    </div>
                    <p class="score" *ngIf="scoresEnabled && flag.score">{{ flag.score }}</p>
                    <svg
                      *ngIf="flag.picture?.key && answer.id == flag.answerId"
                      class="pin-icon"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      style="position: absolute; bottom: 0">
                      <path
                        d="M7.42282 10.5439L1.45659 4.5777C1.35609 4.4772 1.32574 4.32596 1.38037 4.19461C1.43475 4.06303 1.56293 3.97758 1.70519 3.97758C4.027 3.97758 6.11236 2.688 7.14801 0.612354L7.35703 0.194557C7.40728 0.0933302 7.50365 0.0226896 7.6151 0.00447869C7.72678 -0.0134744 7.84014 0.0231818 7.92002 0.103033L11.8975 4.08052C11.9774 4.16039 12.014 4.27376 11.9961 4.38544C11.9778 4.49686 11.9072 4.59324 11.806 4.64351L11.3884 4.85229C9.31249 5.88816 8.02293 7.97351 8.02293 10.2953C8.02293 10.4376 7.93748 10.5658 7.8059 10.6201C7.67456 10.6748 7.52332 10.6444 7.42282 10.5439Z" />
                      <path
                        d="M3.1962 7.3125L0.600143 9.90857C0.561542 9.94717 0.532409 9.99426 0.515182 10.046L0.0180025 11.5375C-0.0239975 11.664 0.00876813 11.8031 0.102963 11.8973C0.197159 11.9915 0.33626 12.0243 0.462753 11.9823L1.95432 11.4851C2.00602 11.4679 2.05313 11.4388 2.09173 11.4002L4.68781 8.80408L3.1962 7.3125Z" />
                    </svg>
                    <i *ngIf="answer.id != flag.answerId" class="fa fa-chain" style="position: absolute; bottom: 0"></i>
                  </div>
                  <div style="flex: 1; padding: 0 20px; max-width: 800px">
                    <p class="main-text" style="word-break: break-word">
                      <span *ngIf="buildingIndex(flag)">#{{ buildingIndex(flag) }} | </span> {{ flag.text }}
                    </p>
                    <p style="margin: 0; font-size: 13px">
                      <span class="username">{{ flag.user?.name }}</span> &nbsp; {{ dateTimeAsString(flag.updatedAt) }}
                      <a
                        href="javascript:void(0)"
                        style="cursor: pointer; font-style: italic; color: #7b8ead"
                        (click)="openChangelog()"
                        >(changelog)</a
                      >
                      &nbsp; <span class="flag-type">{{ flag.subtype?.type?.name }}</span>
                    </p>
                  </div>
                  <div class="icon-right" style="display: flex; flex-direction: column; text-align: right">
                    <div style="flex: 1" cdkDropList>
                      <span cdkDragHandle *ngIf="!flag.pictureId" style="cursor: pointer; font-size: 11px">
                        drag over picture to pin &nbsp;
                        <svg class="pi-icon" height="12" style="fill: #7b8ead" viewBox="0 0 12 12" width="12">
                          <path
                            d="M7.42282 10.5439L1.45659 4.5777C1.35609 4.4772 1.32574 4.32596 1.38037 4.19461C1.43475 4.06303 1.56293 3.97758 1.70519 3.97758C4.027 3.97758 6.11236 2.688 7.14801 0.612354L7.35703 0.194557C7.40728 0.0933302 7.50365 0.0226896 7.6151 0.00447869C7.72678 -0.0134744 7.84014 0.0231818 7.92002 0.103033L11.8975 4.08052C11.9774 4.16039 12.014 4.27376 11.9961 4.38544C11.9778 4.49686 11.9072 4.59324 11.806 4.64351L11.3884 4.85229C9.31249 5.88816 8.02293 7.97351 8.02293 10.2953C8.02293 10.4376 7.93748 10.5658 7.8059 10.6201C7.67456 10.6748 7.52332 10.6444 7.42282 10.5439Z"></path>
                          <path
                            d="M3.1962 7.3125L0.600143 9.90857C0.561542 9.94717 0.532409 9.99426 0.515182 10.046L0.0180025 11.5375C-0.0239975 11.664 0.00876813 11.8031 0.102963 11.8973C0.197159 11.9915 0.33626 12.0243 0.462753 11.9823L1.95432 11.4851C2.00602 11.4679 2.05313 11.4388 2.09173 11.4002L4.68781 8.80408L3.1962 7.3125Z"></path>
                        </svg>

                        <div *cdkDragPreview>
                          <div class="flag-icon">
                            <i class="fa fa-flag"></i>
                          </div>
                          <div class="flag-tooltip">
                            <span class="flag-type" style="color: #eee; font-weight: bold">
                              {{ flag?.subtype?.type?.name }} - {{ flag?.subtype?.name }}
                            </span>
                            <br />
                            <span class="flag-text" style="color: #ddd; overflow-wrap: break-word">
                              {{ flag.text }}
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                    <i style="cursor: pointer" class="fa fa-pencil" (click)="editFlag(flag)"></i>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- section end -->
      </div>

      <h4 *ngIf="!itemCount" style="text-align: center; margin-top: 20%">
        No answers were found matching current filters.
      </h4>

      <div style="display: flex; height: 100%" *ngIf="forceMenu && itemCount">
        <div class="item-column">
          <div class="column-header">
            <h4>
              <span style="float: left"
                >Item <span class="count">({{ itemCount }})</span></span
              >
            </h4>
          </div>
          <div class="scrollable" [perfectScrollbar]>
            <ng-container *ngFor="let item of items; index as i">
              <div
                *ngIf="item.show"
                [ngClass]="{ 'card-active': selectedItemIndex === i }"
                (click)="onClickItem(i)"
                class="card-section">
                <div style="display: flex">
                  <div style="flex: 1">
                    <span class="card-name">{{ item.label }}</span
                    ><br />
                    <div>
                      <div style="display: inline-block; width: 60%">
                        <div class="progress progress-xs">
                          <div class="progress-bar" role="progressbar" [ngStyle]="{ width: item.progress + '%' }"></div>
                        </div>
                      </div>
                      <span class="percentage"> {{ item.progress?.toFixed(0) }}%</span>
                    </div>
                  </div>
                  <i class="fa fa-angle-right arrow"></i>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="section-column">
          <div class="column-header">
            <h4>
              <span style="float: left"
                >Section <span class="count">({{ sectionCount }})</span></span
              >
            </h4>
            <div
              class="dropdown"
              dropdown
              [ngClass]="{ disabled: !(inspection.status == InspectionStatus.NEEDS_REVIEW) }">
              <button type="button" class="btn btn-bulk" dropdownToggle>
                <i class="fa fa-ellipsis-h"></i>
              </button>
              <div class="dropdown-menu right" *dropdownMenu>
                <h6 class="dropdown-header">For all sections in the Item:</h6>
                <a class="dropdown-item" (click)="bulkUpdateAnswers('item', 2)">Mark all questions as accepted</a>
                <a class="dropdown-item" (click)="bulkUpdateAnswers('item', 1)">Mark all questions as rejected</a>
                <a class="dropdown-item" (click)="bulkUpdateAnswers('item', 0)">Reset review status for all question</a>
              </div>
            </div>
          </div>
          <div class="scrollable" [perfectScrollbar]>
            <ng-container *ngFor="let item of sections; index as i">
              <div
                *ngIf="item.show"
                class="card-section"
                (click)="onClickSection(i)"
                [ngClass]="{ 'card-active': selectedSectionIndex === i }">
                <div style="display: flex">
                  <div style="flex: 1">
                    <span class="card-name">{{ item.name }}</span
                    ><br />
                    <div>
                      <div style="display: inline-block; width: 60%">
                        <div class="progress progress-xs">
                          <div class="progress-bar" role="progressbar" [ngStyle]="{ width: item.progress + '%' }"></div>
                        </div>
                      </div>
                      <span class="percentage"> {{ item.progress?.toFixed(0) }}%</span>
                    </div>
                  </div>
                  <i class="fa fa-angle-right arrow"></i>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="question-column">
          <div class="column-header">
            <h4>
              <span style="float: left"
                >Question <span class="count">({{ questionCount }})</span></span
              >
            </h4>
            <div
              class="dropdown"
              dropdown
              [ngClass]="{ disabled: !(inspection.status == InspectionStatus.NEEDS_REVIEW) }">
              <button type="button" class="btn btn-bulk" dropdownToggle>
                <i class="fa fa-ellipsis-h"></i>
              </button>
              <div
                class="dropdown-menu right"
                [ngClass]="{ disabled: !(inspection.status == InspectionStatus.NEEDS_REVIEW) }"
                *dropdownMenu>
                <h6 class="dropdown-header">For all questions in the Section:</h6>
                <a class="dropdown-item" (click)="bulkUpdateAnswers('section', 2)">Mark all questions as accepted</a>
                <a class="dropdown-item" (click)="bulkUpdateAnswers('section', 1)">Mark all questions as rejected</a>
                <a class="dropdown-item" (click)="bulkUpdateAnswers('section', 0)"
                  >Reset review status for all question</a
                >
              </div>
            </div>
          </div>
          <div class="scrollable" forScroll>
            <ng-container *ngFor="let item of questions; index as i">
              <div
                *ngIf="item.show"
                class="card-section"
                tabindex="-1"
                [ngClass]="getQuestionClass(i, item)"
                (click)="onClickQuestion(i); resetQuestion()"
                style="display: flex">
                <div>
                  <div *ngIf="questionStatus(item) === 'default'" class="question-icon default">
                    <i class="fa fa-circle-thin"></i>
                  </div>
                  <div *ngIf="questionStatus(item) === 'accepted'" class="question-icon accepted">
                    <i class="fa fa-check"></i>
                  </div>
                  <div *ngIf="questionStatus(item) === 'rejected'" class="question-icon rejected">
                    <i class="fa fa-times"></i>
                  </div>
                  <div *ngIf="questionStatus(item) === 'flag'" class="question-icon flag">
                    <i class="fa fa-warning"></i>
                  </div>
                  <p class="score">{{ getScore(item) || '' }}</p>
                </div>
                <div class="card-question-text" style="flex: 1">
                  {{ item.text }} <span *ngIf="item.mandatoryReview" style="color: red; font-weight: bold">*</span>
                  <div class="question-icons">
                    <span *ngIf="nComments(item)"><i class="fa fa-comment"></i> {{ nComments(item) }}</span>
                    <span *ngIf="nPictures(item)"><i class="fa fa-camera"></i> {{ nPictures(item) }}</span>
                    <span *ngIf="nFlags(item)" class="flag"><i class="fa fa-flag"></i> {{ nFlags(item) }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div
      id="right-column"
      [ngClass]="{ accepted: inspection?.accepted, rejected: inspection?.rejected }"
      style="display: flex; flex-direction: column; height: 100%">
      <div style="font-size: 13px; font-weight: 500; margin-left: 30px">
        Reviewing inspection / {{ inspection?.customerName }} #{{ inspection?.policyNumber }}
      </div>

      <div style="margin: 0 15px 10px 20px; display: flex" *ngIf="inspection" class="">
        <button
          type="button"
          (click)="contentRight = 'overview'"
          title="Overview"
          class="btn btn-ghost-primary aru"
          *ngIf="contentRight != 'overview'"
          style="margin: 20px 15px 5px 5px; padding: 8px 12px; font-size: 19px; float: left; width: 46px; height: 46px">
          <i class="fa fa-home"></i>
        </button>

        <button
          type="button"
          (click)="contentRight = 'question'"
          title="Question"
          class="btn btn-ghost-primary aru"
          *ngIf="contentRight != 'question'"
          style="margin: 20px 15px 5px 5px; padding: 8px 12px; font-size: 19px; float: left; width: 46px; height: 46px">
          <i class="fa fa-chevron-left"></i>
        </button>

        <div id="header" style="flex: 1">
          <div class="stat">
            <div class="value">{{ getInspectionProgress().toFixed(0) }}%</div>
            <span style="color: #000; font-size: 13px">Reviewed</span>
            <div class="progress progress-xs" style="margin: 0">
              <div class="progress-bar" role="progressbar" [ngStyle]="{ width: getInspectionProgress() + '%' }"></div>
            </div>
          </div>
          <div class="stat">
            <div class="value">{{ getInspectionMandatoryProgress().toFixed(0) }}%</div>
            <span style="color: #000; font-size: 13px">Mandatory</span>
            <div class="progress progress-xs" style="margin: 0">
              <div
                class="progress-bar"
                role="progressbar"
                [ngStyle]="{ width: getInspectionMandatoryProgress() + '%' }"></div>
            </div>
          </div>
          <div [ngClass]="{ disabled: !totalRejected }" class="stat red">
            <div class="value">{{ totalRejected }}</div>
            <span class="label">Rejected</span>
          </div>
          <div
            [ngClass]="{ disabled: !totalFlags }"
            class="stat"
            style="cursor: pointer"
            (click)="contentRight = 'flags'">
            <div class="value">{{ totalFlags }}</div>
            <span class="label">Flags</span>
          </div>
          <div
            [ngClass]="{ disabled: !totalComments }"
            class="stat"
            style="cursor: pointer"
            (click)="contentRight = 'comments'">
            <div class="value">{{ totalComments }}</div>
            <span class="label">Comments</span>
          </div>
          <div [ngClass]="{ disabled: !nLocations }" class="stat" style="cursor: pointer" (click)="goToLocations()">
            <div class="value">{{ nLocations }}</div>
            <span class="label">Locations</span>
          </div>
        </div>

        <br style="clear: both" />
      </div>

      <div
        *ngIf="inspection && contentRight == 'overview'"
        class="scrollable"
        style="padding: 0 30px"
        [perfectScrollbar]>
        <h2 class="inspection-summary">Inspection Summary</h2>
        <p class="setting"><a [routerLink]="'/inspection/form/' + inspection.id">Inspection Setup</a></p>
        <br />

        <table class="tb-summary">
          <tr>
            <td>Policy:</td>
            <td>
              <a [routerLink]="'/policy/form/' + inspection.policy.id">{{ inspection.policyNumber }}</a>
            </td>
            <td>Purpose:</td>
            <td>{{ inspection.purpose }}</td>
          </tr>
          <tr>
            <td>Customer:</td>
            <td>{{ inspection.customerName }}</td>
            <td>Vendor:</td>
            <td *ngIf="!inspection.vendor">-</td>
            <td *ngIf="inspection.vendor">
              <a [routerLink]="'/vendor/form/' + inspection.vendor.id">{{ inspection.vendor?.name }}</a>
            </td>
          </tr>
          <tr>
            <td>Contact:</td>
            <td>{{ inspection.contactName }}</td>
            <td>Inspector:</td>
            <td *ngIf="!inspection.inspector">-</td>
            <td *ngIf="inspection.inspector">
              <a [routerLink]="'/inspector/form/' + inspection.inspector.id">{{ inspection.inspector?.name }}</a>
            </td>
          </tr>
          <tr>
            <td>Mobile:</td>
            <td>{{ inspection.contactPhone }}</td>
            <td>Last synced:</td>
            <td>{{ dateAsString(inspection.lastSynced) }}</td>
          </tr>
          <tr>
            <td>Email:</td>
            <td>{{ inspection.contactEmail }}</td>
            <td>Completed:</td>
            <td>{{ dateAsString(inspection.completed) }}</td>
          </tr>
          <tr>
            <td>Location:</td>
            <td>{{ inspection.address }}, {{ inspection.city }}, {{ inspection.state }}</td>
            <td>Inspection Score:</td>
            <td>{{ inspection.flaggingScore || '-' }}</td>
          </tr>
          <tr>
            <td *ngIf="inspection.policy?.broker">Broker:</td>
            <td *ngIf="inspection.policy?.broker">
              <a [routerLink]="'/broker/form/' + inspection.policy.broker.id">{{ inspection.policy.broker.name }}</a>
            </td>
            <td>Rating:</td>
            <td>{{ inspection.rating || '-' }}</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>Rating Note:</td>
            <td style="max-width: 80px; white-space: pre-wrap; overflow-wrap: break-word">
              {{ inspection.ratingNote || '-' }}
            </td>
          </tr>
        </table>

        <div class="summary-stats">
          <div (click)="contentRight = 'question'">
            <h6>{{ countAnsweredAnswers(answers) }}</h6>
            <p>Questions answered</p>
          </div>
          <div [ngClass]="{ disabled: !totalFlags }" (click)="contentRight = 'flags'">
            <h6>{{ totalFlags }}</h6>
            <p>Flags</p>
          </div>
          <div [ngClass]="{ disabled: !getFilteredCommentCount() }" (click)="contentRight = 'comments'">
            <h6>{{ getFilteredCommentCount() }}</h6>
            <p>Inspector Comments</p>
          </div>
          <div
            [ngClass]="{ disabled: !getImageCount() }"
            [routerLink]="'/inspection/review/gallery/' + inspection.id"
            queryParamsHandling="merge">
            <h6>{{ getImageCount() }}</h6>
            <p>Images</p>
          </div>
          <div [ngClass]="{ disabled: !nLocations }" (click)="goToLocations()" queryParamsHandling="merge">
            <h6>{{ nLocations }}</h6>
            <p>Locations</p>
          </div>
        </div>

        <div
          class="inspection-action"
          [ngClass]="{
            red: inspection.status == InspectionStatus.REJECTED,
            green:
              inspection.status == InspectionStatus.ACCEPTED ||
              (inspection.status == InspectionStatus.NEEDS_REVIEW && getInspectionMandatoryProgress() === 100)
          }">
          <div *ngIf="inspection.status == InspectionStatus.NEEDS_REVIEW">
            <em>Accept or Reject</em> this inspection.
          </div>
          <div *ngIf="inspection.status == InspectionStatus.ACCEPTED">The inspection is now <em>completed</em></div>
          <div *ngIf="inspection.status == InspectionStatus.ACCEPTED" class="badge">ACCEPTED</div>
          <div *ngIf="inspection.status == InspectionStatus.REJECTED">The inspection was <em>rejected</em></div>
          <div *ngIf="inspection.status == InspectionStatus.REJECTED" class="badge red">REJECTED</div>
        </div>

        <div
          class="inspection-btns"
          *ngIf="!(inspection.status == InspectionStatus.ACCEPTED || inspection.status == InspectionStatus.REJECTED)">
          <button
            type="button"
            class="btn aru"
            [ngClass]="{
              disabled: !(inspection.status == InspectionStatus.NEEDS_REVIEW),
              'btn-outline-danger': inspection.status == InspectionStatus.NEEDS_REVIEW
            }"
            (click)="bulkUpdateAnswers('inspection', 1)">
            Reject
          </button>
          <button
            type="button"
            [ngClass]="{
              disabled: !(inspection.status == InspectionStatus.NEEDS_REVIEW),
              'btn-outline-success': inspection.status == InspectionStatus.NEEDS_REVIEW
            }"
            class="btn aru"
            (click)="bulkUpdateAnswers('inspection', 2)">
            Accept
          </button>
        </div>

        <div
          class="inspection-btns"
          *ngIf="inspection.status == InspectionStatus.ACCEPTED || inspection.status == InspectionStatus.REJECTED">
          <button class="btn btn-ghost-primary aru" (click)="reopen()">
            <i class="fa fa-rotate-right" style="margin-right: 10px"></i> Reopen
          </button>
        </div>
      </div>

      <div *ngIf="contentRight == 'flags'" id="flagSummary" class="scrollable" style="padding: 0 30px" forScroll>
        <h1 style="margin: 20px 0 20px">Flags</h1>

        <div>
          <label style="float: left; margin: 0 10px 0 0px" class="switch switch-pill switch-success"
            ><input [(ngModel)]="showOnlyFlagsWithPictures" class="switch-input" type="checkbox" /><span
              class="switch-slider"></span
          ></label>
          <div style="float: left; font-weight: 500">Show only flags with pictures</div>
        </div>
        <br style="clear: both" />

        <div id="allFlags">
          <div *ngFor="let section of filteredFlags" [attr.section]="section.label" class="flag-section">
            <h6 style="margin-top: 30px">{{ section.label }}</h6>

            <ng-container *ngFor="let flag of section.flags; index as i">
              <div
                [ngClass]="getFlagHighlightClass(flag)"
                (click)="gotoQuestion(flag)"
                [attr.question]="flag.question"
                class="flag flag-info">
                <div style="position: relative">
                  <div class="icon-left">
                    <i *ngIf="!scoresEnabled || !flag.score" class="fa fa-flag"></i>
                    <i *ngIf="scoresEnabled && flag.score" class="fa fa-warning"></i>
                  </div>
                  <p class="score" *ngIf="scoresEnabled && flag.score">{{ flag.score }}</p>
                  <svg
                    *ngIf="flag.picture?.key"
                    class="pin-icon"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    style="position: absolute; bottom: 0">
                    <path
                      d="M7.42282 10.5439L1.45659 4.5777C1.35609 4.4772 1.32574 4.32596 1.38037 4.19461C1.43475 4.06303 1.56293 3.97758 1.70519 3.97758C4.027 3.97758 6.11236 2.688 7.14801 0.612354L7.35703 0.194557C7.40728 0.0933302 7.50365 0.0226896 7.6151 0.00447869C7.72678 -0.0134744 7.84014 0.0231818 7.92002 0.103033L11.8975 4.08052C11.9774 4.16039 12.014 4.27376 11.9961 4.38544C11.9778 4.49686 11.9072 4.59324 11.806 4.64351L11.3884 4.85229C9.31249 5.88816 8.02293 7.97351 8.02293 10.2953C8.02293 10.4376 7.93748 10.5658 7.8059 10.6201C7.67456 10.6748 7.52332 10.6444 7.42282 10.5439Z" />
                    <path
                      d="M3.1962 7.3125L0.600143 9.90857C0.561542 9.94717 0.532409 9.99426 0.515182 10.046L0.0180025 11.5375C-0.0239975 11.664 0.00876813 11.8031 0.102963 11.8973C0.197159 11.9915 0.33626 12.0243 0.462753 11.9823L1.95432 11.4851C2.00602 11.4679 2.05313 11.4388 2.09173 11.4002L4.68781 8.80408L3.1962 7.3125Z" />
                  </svg>
                </div>
                <div style="flex: 1; padding: 0 20px">
                  <p class="main-text">{{ flag.question }}</p>
                  <p style="margin: 0 0 10px; font-size: 13px">{{ flag.text }}</p>
                  <p style="margin: 0; font-size: 13px">
                    <span class="username">{{ flag.user?.name }}</span> &nbsp;
                    {{ dateTimeAsString(flag.updatedAt) }}&nbsp;
                    <span class="flag-type">{{ flag.subtype?.type?.name }}</span>
                  </p>
                </div>
                <div style="color: #f3d6d5"><i class="fa fa-chevron-right"></i></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div *ngIf="contentRight == 'comments'" class="scrollable" style="padding: 0 30px" forScroll>
        <h1 style="margin: 20px 0 20px">Comments</h1>

        <div>
          <label style="float: left; margin: 0 10px 0 0px" class="switch switch-pill switch-success"
            ><input [(ngModel)]="showOnlyInspectorsComments" class="switch-input" type="checkbox" /><span
              class="switch-slider"></span
          ></label>
          <div style="float: left; font-weight: 500">Show only inspector's comments</div>
        </div>

        <br style="clear: both" />
        <div id="allComments">
          <div *ngFor="let section of filteredComments" [attr.section]="section.label" class="comment-section">
            <h6 style="margin-top: 30px">{{ section.label }}</h6>

            <div
              style="
                background-color: #f7f9fd;
                border-radius: 4px;
                color: #3465c4;
                padding: 15px;
                margin-bottom: 15px;
                display: flex;
                cursor: pointer;
              "
              (click)="gotoQuestion(comment)"
              *ngFor="let comment of section.comments"
              [attr.question]="comment.question"
              class="comment-info">
              <div><i class="fa fa-comment"></i></div>
              <div style="flex: 1; padding: 0 20px">
                <p style="font-weight: bold; margin: 0">{{ comment.question }}</p>
                <p style="color: #444; margin: 0; font-size: 13px">{{ comment.text }}</p>
                <p style="color: #444; margin: 0; font-size: 13px">
                  Comment added: {{ dateAsString(comment.date) }} / {{ comment.username }}
                </p>
              </div>
              <div style="color: #d6e0f3"><i class="fa fa-chevron-right"></i></div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="question && contentRight == 'question'"
        #questionDiv
        style="flex: 1; display: flex; flex-direction: column; padding-bottom: 0px !important"
        class="scrollable"
        forScroll>
        <h4 style="padding: 20px 20px 0">
          {{ question.legacyId ? question.legacyId + '. ' : '' }} {{ question.text }}
        </h4>

        <app-answer-form
          #answerForm
          *ngIf="question.repeat?.length === 0"
          [answer]="answer"
          [question]="question"
          [inspection]="inspection"
          [readOnly]="answersReadOnly"
          (statusChange)="answerStatusChange($event)"
          (answerChange)="answerChange($event)"
          (openPictureFlag)="openPictureFlag($event)"
          (setPictures)="answerSetPictures($event)"
          (updateAnswer)="updateAnswerLocally($event.answer)"
          (previousQuestion)="previous()"
          (nextQuestion)="next()"
          (updateCounter)="getFlagsAndComments()"
          style="flex: 1; display: flex; flex-direction: column">
        </app-answer-form>

        <div *ngIf="question.repeat?.length > 0" style="padding: 0 20px">
          <div class="row">
            <div
              [ngClass]="{ 'col-xl-6': question.answer?.length > 1, 'col-xl-12': question.answer?.length == 1 }"
              *ngFor="let a of question.answer; index as i">
              <div class="card">
                <div class="card-header" style="color: #3465c4; font-weight: 500; background-color: white">
                  Building #{{ i + 1 }}
                </div>
                <div class="card-body custom-card">
                  <app-answer-form
                    [answer]="a"
                    [question]="question"
                    [readOnly]="answersReadOnly"
                    [inspection]="inspection"
                    (statusChange)="answerStatusChange($event, true)"
                    (answerChange)="answerChange($event)"
                    (setPictures)="answerSetPictures($event)"
                    (updateAnswer)="updateAnswerLocally($event.answer)"
                    [showNavigation]="false"
                    (updateCounter)="getFlagsAndComments()"
                    style="display: grid; min-height: 500px"
                    class="according-pane">
                  </app-answer-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="question && contentRight == 'question' && question.repeat?.length > 0" style="padding-top: 15px">
        <button
          type="button"
          class="btn aru"
          (click)="previous()"
          style="width: 46px; padding: 0; height: 46px; color: #2763cd; margin: 0px 5px 0 20px; float: left">
          <i class="fa fa-arrow-left"></i>
        </button>

        <button
          type="button"
          class="btn aru"
          (click)="next()"
          style="width: 46px; padding: 0; height: 46px; color: #2763cd; margin: 0px 20px 0 5px; float: right">
          <i class="fa fa-arrow-right"></i>
        </button>
        <div style="text-align: center; margin-bottom: 20px" *ngIf="question?.answer?.length > 1">
          <button
            type="button"
            class="btn aru btn-success"
            [ngClass]="{ 'btn-ghost-success': !allAccepted(), 'btn-success': allAccepted() }"
            (click)="acceptAll()">
            {{ allAccepted() ? 'All accepted' : 'Accept All & next' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-rate-inspection #rating></app-rate-inspection>
  <app-add-flag #addFlagModal></app-add-flag>
  <app-edit-flag #editFlagModal></app-edit-flag>
</div>
